import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"

import Index from './Index/View'
import Pegawai from './Pegawai/View'
import AddPegawai from './AddPegawai/View'
import VerifikasiPegawai from './VerifikasiPegawai/View'
import Create from './Create/View'
import BerkasUpload from './BerkasUpload/View'
import DetailPegawai from './DetailPegawai/View'
import CreateRevisi from './CreateRevisi/View'


const RouteView = (props) => {
    const { params } = props    
	const queryParams = new URLSearchParams(props.location.search);
    const _id = queryParams.get('id')
    const _uuid = queryParams.get('uuid')
    const _pegawai_uuid = queryParams.get('pegawai_uuid')
    const _create = queryParams.get('create')
    const _list = queryParams.get('list')
    const _detail = queryParams.get('detail')
    const _update = queryParams.get('update')
    const _delete = queryParams.get('delete')
    const _approve = queryParams.get('approve')
    const _print = queryParams.get('print')
    const _pegawai = queryParams.get('pegawai')
    const _addpegawai = queryParams.get('addpegawai')
    const _verifikasi = queryParams.get('verifikasi')
    const _berkas = queryParams.get('berkas')
    const update_grade = queryParams.get('update_grade')

    const create_revisi = queryParams.get('create_revisi')


    if (_pegawai != null) {
        return accessRole('update') ? <Pegawai uuid={_uuid}  /> : <ErrorAccess />
    }
    if (_addpegawai != null) {
        return accessRole('update') ? <AddPegawai uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_verifikasi != null) {
        return accessRole('update') ? <VerifikasiPegawai uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_create != null) {
        return accessRole('create') ? <Create/> : <ErrorAccess />
    }
    if (_berkas != null) {
        return accessRole('update') ? <BerkasUpload uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_detail != null) {
        return accessRole('read') ? <DetailPegawai uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (create_revisi != null) {
        return accessRole('read') ? <CreateRevisi uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (update_grade != null) {
        return accessRole('read') ? <CreateRevisi uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    // Jika Admin
    if (accessRole('approve')) {
        return accessRole('read') ? <Index /> : <ErrorAccess />
    } else {
        return accessRole('read') ? null : <ErrorAccess />
    }

}

export default RouteView